<template>
  <div class="file-upload">
    <!-- {{_value}} -->
    <div v-if="mode === 'DESIGN'" class="disabled-box">
      <el-button size="mini" class="btn-upload" ><i class="icon-zip" />上传附件</el-button>
      <!-- <ellipsis :row="1" :content="placeholder + sizeTip" hoverTip slot="tip" class="el-upload__tip" /> -->
    </div>
    <template v-else>
      <template v-if="!readerMode  || perm==='E'">
        <div class="upload-container" :class="{'hide-upload':maxNumber>0&&_value.length>=maxNumber }">
          <el-upload
            :file-list="_value"
            :show-file-list="false"
            action="#"
            :limit="maxNumber"
            with-credentials
            :multiple="maxNumber !== 1"
            :on-exceed="handleExceed"
            :data="uploadParams"
            :auto-upload="true"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :http-request="uploadFile"
            :disabled="perm==='R'||pendingApprovalUploads>0"
          >
            <!-- <el-button size="small" icon="el-icon-paperclip" round>上传附件</el-button> -->
            <el-button size="mini" :class="perm==='R'?'btn-upload btn-upload-disabled':'btn-upload'" ><i class="icon-zip" />上传附件</el-button>
            <!-- <ellipsis :row="1" :content="placeholder + sizeTip" hoverTip slot="tip" class="el-upload__tip" /> -->
          </el-upload>
          <approval-attachment-list ref="attachments" :files="_value" :removable="perm!=='R'&&perm!=='H'&&!pendingApprovalUploads" @remove="handleRemove"/>
          <div v-if="pendingApprovalUploads" class="upload-progress">正在上传 {{pendingApprovalUploads}} 个附件，请稍候…</div>
        </div>
      </template>
      <template v-else>
        <approval-attachment-list ref="attachments" :files="_value"/>
      </template>
    </template>
   
    
    
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins';
// import { upLoadFileApi, downLoadFileApi } from '@/api/design';
import { uploadApprovalAttachment } from './approvalAttachmentUpload';
import ApprovalAttachmentList from '@/components/ApprovalAttachmentList.vue';
export default {
  mixins: [componentMinxins],
  name: 'FileUpload',
  components: {ApprovalAttachmentList},
  props: {
    placeholder: {
      type: String,
      default: '请选择附件',
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    maxSize: {
      type: Number,
      default: 8,
    },
    maxNumber: {
      type: Number,
      default: 20,//0不限制；新附件字段默认支持20个
    },
    fileTypes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    readerMode: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    sizeTip() {
      if (this.fileTypes.length > 0) {
        return ` | 只允许上传[${String(this.fileTypes).replaceAll(',', '、')}]格式的文件，且单个附件不超过${this.maxSize}MB`;
      }
      // return this.maxSize > 0 ? ` | 单个附件不超过${this.maxSize}MB` : '';
      return this.maxSize > 0 ? `` : '';
    },
    _value: {
      get: function () {
        return this.localValue;
      },
      set: function (e) {
        this.localValue=e;
        this.$emit("input", e);
      },
    },
  },
  data() {
    return {
      disabled: false,
      uploadParams: {},
      localValue: this.value || [],
      pendingApprovalUploads: 0,
      uploadQueue: Promise.resolve()
    };
  },
  watch:{value(value){if(!this.pendingApprovalUploads)this.localValue=value||[];}},
  methods: {
           // 覆盖默认的上传行为
           requestUpload() {
            
           },
    // beforeUpload(file) {

      // const alows = [];
      // if (alows.indexOf(file.type) === -1) {
      //   this.$message.warning('存在不支持的图片格式');
      // } else 
      // if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
      //   this.$message.warning(`单张图片最大不超过 ${this.maxSize}MB`);
      // } else {
      //    //上传文件的需要formdata类型;所以要转
      //    let FormDatas = new FormData();
      //   FormDatas.append('file', file);
        // upLoadFileApi(FormDatas).then(res => {
        // console.log('uploadFile', res);

        // if (res.data.result) {
        //     this._value.push(res.data.result); //成功过后手动将文件添加到展示列表里
        //     this.$emit('input', this._value);
        //   }
        // });

    //     return true;
    //   }
    //   return false;
    // },
    beforeUpload(file) {
      if(this.perm==='R'||this.perm==='H')return false;
      if(this.maxNumber>0&&this._value.length+this.pendingApprovalUploads>=this.maxNumber){this.handleExceed();return false;}
      if(!file.size){this.$message.warning('不能上传空文件');return false;}
      const ext=(file.name||'').split('.').pop().toLowerCase();
      if(this.fileTypes.length&&ext!=='rar'&&!this.fileTypes.some(t=>ext===String(t).replace(/^\./,'').toLowerCase())){this.$message.warning('附件格式不符合表单要求');return false;}
      if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单个文件最大不超过 ${this.maxSize}MB`);
      } else {
        this.pendingApprovalUploads++;
        this.uploadQueue=this.uploadQueue.then(()=>this.uploadFile(file)).finally(()=>{this.pendingApprovalUploads--});
      }
      return false;
    },
    handleExceed(){this.$message.warning('最多上传'+this.maxNumber+'个附件');},
    async uploadFile(file) {
      try {
        const result = await uploadApprovalAttachment(file);
        this._value = [...this._value, {url:result.url, name:file.name, uid:result.id || file.uid}];
        await this.$nextTick();
      } catch (error) {
        this.$message.error((file.name||'附件')+'：'+(error.message || '上传失败，请重试'));
      }
    },
    handleRemove(file, fileList) {
      if(this.perm==='R'||this.perm==='H'||this.pendingApprovalUploads)return;
      this._value=this._value.filter(item=>file.uid?item.uid!==file.uid:item.url!==file.url);
    },
    handlePreview(file) {
      if(this.$refs.attachments)this.$refs.attachments.view(file);
    },
    handleDownload(file) {
        //上传文件的需要formdata类型;所以要转
      let FormDatas = new FormData();
      FormDatas.append('name', file.name);
      // downLoadFileApi(FormDatas).then(res => {
      //   if (res.data) {
      //     downloadFileBlob(res.data,file.name)
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.file-upload {
  display: block;
  min-height: 32px;
  font-size: 0;
  line-height: 1.5;
  margin-top: 6px;
  .form-item-text{
    font-size: 14px;
    padding-top: 5px;
    overflow-wrap:anywhere;
  }
  .upload-progress{font-size:12px;color:#909399;line-height:1.6;margin-top:8px}
}

.btn-upload{
  width: 108px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #E3E6E5;
  padding:0;
  display:flex;
  align-items:center;
  justify-content:center;
  /deep/ span{
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:14px;
    font-weight:normal;
    color:#2F3030;
    &:hover{
      color:#2F3030;
    }
  }
}
.btn-upload-disabled{
  background: #F5F7FA;
  cursor: not-allowed;
  border-color: #E4E7ED;
  .icon-zip{
    opacity: .5;
  }
  /deep/ span{
    color:#C0C4CC;
    &:hover{
      color:#C0C4CC;
    }
  }
}
.icon-zip{
  display:inline-block;
  width:16px;
  height:16px;
  background-image: url('~@/pages/officeApproval/common/icon/icon-zip.png');
  margin-right:2px;
}
.hide-upload{
    /deep/.el-upload{
      display: none;
    }
  }
  .upload-container /deep/ {
    .el-upload-list__item{
      line-height: 30px;
      .el-icon-close{
        padding: 3px;
      }
      &:first-child {
          margin-top: 7px;
      }
      .el-icon-close-tip{
        font-size: 0;
      }
    }
    .el-upload-list__item-name{
      margin-right: 25px;
    }
  }
  .el-icon-close-tip{
    display: none;
  }
 
</style>
